import styled, { css } from 'styled-components'

export const Container = styled.section`
  ${({ templateColumns }) => css`
    color: var(--text-tertiary);
    font-size: var(--font-size-sm);
    width: 100%;
    table-layout: auto;
    ul {
      display: grid;
      padding: 24px;
      grid-template-columns: ${templateColumns ||
      'repeat(auto-fit, minmax(10px, 1fr))'};
      gap: 8px;

      li {
        display: flex;
        justify-content: center;
        align-items: center;

        > span {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 100%;
          text-align: center;
        }

        > input {
          width: 100%;
        }
      }

      @media (max-width: 900px) {
        grid-template-columns: 1fr;
        grid-template-rows: repeat(7, 1fr);
        gap: 10px;
        padding: 0px;
        font-size: var(--font-size-md);
        justify-content: space-between;
        align-content: center;

        li {
          text-align: center;
        }
      }
    }

    header {
      ul {
        margin-bottom: 32px;
        padding-top: 8px;

        li {
          font-weight: bold;
        }
      }
    }

    main {
      ul {
        background: var(--background-table);
        border: 1px solid var(--border-color-table);
        border-radius: 13px;

        &:not(:last-child) {
          margin-bottom: 8px;
        }

        /* :hover {
          background-color: var(--border-color-table);
          color: var(--text-primary);
          cursor: pointer;
        } */
      }
    }

    footer {
      margin-top: 16px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 8px;
    }
  `}
`
